// removed by extract-text-webpack-plugin
module.exports = {"dropdownButton":"ee_ef","dropdown":"ee_eg","dropdownLg":"ee_eh"};


//////////////////
// WEBPACK FOOTER
// ./src/decorators/decorators.module.scss
// module id = 1754
// module chunks = 0